import { useSelector } from "react-redux";
import { inProgress, isNullOrUndefined } from "../../../../../common/utils";

function useGetUserListApiCallStatus() {
  const { progress, error } = useSelector((rootState) => rootState.userList.userList);

  return {
    userListApiCallProgress: inProgress(progress),
    userListApiCallError: !isNullOrUndefined(error),
  };
}

export default useGetUserListApiCallStatus;
